export default __webpack_public_path__ + "static/logo-white-00e31720592397d243da4185ebaf230b.svg";